import type { MetadataStatus } from '@atlaskit/linking-common/types';

const CARD_APPEARANCE_CACHE_KEY_SUFFIXES = ['|inline', '|block', '|embed'] as const;

const isValidUrl = (url: string): boolean => {
	try {
		new URL(url);
		return true;
	} catch {
		return false;
	}
};

export const getUrlAndMetadataStatus = (
	cacheKey: string,
): { metadataStatus: MetadataStatus; url: string } => {
	for (const suffix of CARD_APPEARANCE_CACHE_KEY_SUFFIXES) {
		if (cacheKey.endsWith(suffix)) {
			const strippedUrl = cacheKey.slice(0, -suffix.length);
			// Only treat as appearance-keyed if the remainder is a valid URL,
			// preventing false positives for URLs that legitimately end with |inline etc.
			if (isValidUrl(strippedUrl)) {
				return {
					metadataStatus: suffix === '|inline' ? 'pending' : 'resolved',
					url: strippedUrl,
				};
			}
		}
	}

	return { metadataStatus: 'resolved', url: cacheKey };
};
